export const PrimaryColor = "#0E7395";
export const TabColor = "#363636";
export const LineColor = PrimaryColor;
